import React, { createContext, useContext, useState } from 'react'
import { useAcompanhamentoApasService } from './useAcompanhamentoApasService'
import { useExcelGenerator } from '../../../../hooks/useExcelGenerator'
import { usePdfGeneratorNew } from '../../../../hooks/usePdfGenerator'
import { useToast } from '@chakra-ui/react'
import { format } from 'date-fns'

const AcompanhamentoApasContext = createContext({})

export const AcompanhamentoApasProvider = ({ children }) => {
  const apasService = useAcompanhamentoApasService()
  const { generateExcel, loading: excelLoading } = useExcelGenerator()
  const { generatePDF, loading: pdfLoading } = usePdfGeneratorNew()
  const toast = useToast()
  const [clienteSelecionado, setClienteSelecionado] = useState(null)

  const excelHeader = ['ID', 'Data Cadastro', 'Nome Cliente', 'Empresa', 'Telefone', 'Vendedor']

  const formatarData = (dataString) => {
    if (!dataString) return 'N/A'

    try {
      return format(new Date(dataString), 'dd/MM/yyyy HH:mm')
    } catch (e) {
      return dataString
    }
  }

  const exportarExcel = () => {
    try {
      if (!apasService.clientes || apasService.clientes.length === 0) {
        toast({
          title: 'Sem dados',
          description: 'Não há clientes para exportar',
          status: 'warning',
          duration: 3000,
          isClosable: true,
        })
        return
      }

      const dataItems = apasService.clientes.map((cliente) => ({
        id: cliente.id,
        data_cadastro: formatarData(cliente.data_cadastro),
        nome_cliente: cliente.nome_cliente,
        empresa: cliente.empresa || 'Não informado',
        celular: cliente.celular?.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3') || 'Não informado',
        nome_vendedor: cliente.nome_vendedor || 'Não atribuído',
      }))

      generateExcel(excelHeader, dataItems, 'Clientes-APAS')
    } catch (error) {
      toast({
        title: 'Erro na exportação',
        description: 'Não foi possível gerar o arquivo Excel',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
      console.error(error)
    }
  }

  const exportarPDF = () => {
    try {
      if (!apasService.clientes || apasService.clientes.length === 0) {
        toast({
          title: 'Sem dados',
          description: 'Não há clientes para exportar',
          status: 'warning',
          duration: 3000,
          isClosable: true,
        })
        return
      }

      const pdfData = apasService.clientes.map((cliente) => [
        cliente.id,
        formatarData(cliente.data_cadastro),
        cliente.nome_cliente,
        cliente.empresa || 'Não informado',
        cliente.celular?.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3') || 'Não informado',
        cliente.nome_vendedor || 'Não atribuído',
      ])

      generatePDF(excelHeader, pdfData, 'Clientes-APAS')
    } catch (error) {
      toast({
        title: 'Erro na exportação',
        description: 'Não foi possível gerar o arquivo PDF',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
      console.error(error)
    }
  }

  const contextValue = {
    ...apasService,
    exportarPDF,
    exportarExcel,
    pdfLoading,
    excelLoading,
    clienteSelecionado,
    setClienteSelecionado,
  }

  return <AcompanhamentoApasContext.Provider value={contextValue}>{children}</AcompanhamentoApasContext.Provider>
}

export const useAcompanhamentoApas = () => useContext(AcompanhamentoApasContext)
